import AuthService from "src/function/auth/AuthService";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "src/context";
import doneNotify from "src/notifications/doneNotify";
import errorNotify from "src/notifications/errorNotify";


const useLogin = () => {
  const navigate = useNavigate();
  const { setIsAuth } = useContext(AuthContext)

  const loginUser = async (email: string, password: string) => {
    const fetchLogin = await AuthService.fetchLoginUser(email, password);

    if (fetchLogin.status === 'success') {
      localStorage.setItem('auth', 'true')
      setIsAuth(true);
      doneNotify('Вы успешно авторизировались');
      navigate('/home');
    } else {
      errorNotify('Возникла ошибка при логине')
    }
  }

  return [loginUser]
}

export default useLogin